module.exports = __webpack_public_path__ + "img/enprimeur.0ba0fe8.png";